import {
    FETCH_USER_PROFILE_BASE_FETCHING,
    FETCH_USER_PROFILE_BASE_SUCCESS,
    FETCH_USER_PROFILE_BASE_FAIL
} from '../../actions/ActionTypes';

const INITIAL_STATE = {
    userProfileBase: false,
    userProfileBaseFetching: false,
    userProfileBaseFetchFail: false,
    userProfileBaseFetchFinished: false
};

const userProfileBaseFetching = (state) => {
    return {
        ...state,
        userProfileBaseFetching: true,
        userProfileBaseFetchFinished: false,
        userProfileBaseFetchFail: false
    };
};

const userProfileBaseFetchFinished = (state, action) => {
    return {
        ...state,
        userProfileBase: action.data,
        userProfileBaseFetching: false,
        userProfileBaseFetchFinished: true,
        userProfileBaseFetchFail: false
    };
};

export const getUserProfileBase = (state) => {
    return state.userProfileBase.userProfileBase;
};

export const isUserProfileBaseFetching = (state) => {
    return state.userProfileBase.userProfileBaseFetching;
};

export const isUserProfileBaseFetchFinished = (state) => {
    return state.userProfileBase.userProfileBaseFetchFinished;
};

export const isUserProfileBaseFetchFail = (state) => {
    return state.userProfileBase.userProfileBaseFetchFail;
};

const handlers = {
    [FETCH_USER_PROFILE_BASE_FETCHING]: userProfileBaseFetching,
    [FETCH_USER_PROFILE_BASE_SUCCESS]: userProfileBaseFetchFinished,
    [FETCH_USER_PROFILE_BASE_FAIL]: userProfileBaseFetchFinished
};

export default function userProfileBase(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
